import script from "./NavBarComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBarComponent.vue?vue&type=script&setup=true&lang=js"

import "./NavBarComponent.vue?vue&type=style&index=0&id=1deec00e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1deec00e"]])

export default __exports__